import React from 'react';
import { Link, useLocation } from 'react-router-dom';
 
const MenuItems = (props) => {
    
    const { parentMenu } = props;

    const location = useLocation();
    const postURL = location.pathname.split('/'); 
    const pathLength = Number(postURL.length)

    return (
        <>
            <li className={location.pathname === '/' ? 'menu-active' : ''}>
                <Link to="/">Home</Link>
            </li>
            <li className={parentMenu === 'about' ? 'menu-active' : ''}>
                <Link to="/about">About</Link>
            </li>
            <li className={location.pathname === '/course-sidebar' ? 'menu-active' : ''}>
                <Link to="/course-sidebar">Tests</Link>
            </li>
        </>
    );
}

export default MenuItems;